import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import NoDataScreen from "../../EmptyScreen/EmptyScreen";
import images from "../../../assets/Icons/Icons";

const EMOTION_META: Record<
  string,
  { emoji: string; color: string; label: string }
> = {
  excited: { emoji: "😃", color: "#F85D48", label: "Excited" },
  curious: { emoji: "😮", color: "#F68C2B", label: "Curious" },
  happy: { emoji: "😊", color: "#FFC047", label: "Happy" },
  bored: { emoji: "😐", color: "#00AD5E", label: "Bored" },
  tired: { emoji: "😣", color: "#76B8F5", label: "Tired" },
  calm: { emoji: "🙂", color: "rgba(126, 233, 255, 1)", label: "calm" },
  sad: { emoji: "😔", color: "#9747FF", label: "Sad" },
  angry: { emoji: "😠", color: "#7EBEFF", label: "Angry" },
};

const mapEmotionsToChartData = (emotions: Record<string, number>) => {
  if (!emotions) return [];

  return Object.entries(emotions).map(([key, value]) => {
    const meta = EMOTION_META[key] || {
      emoji: "🙂",
      color: "#999",
      label: key,
    };

    return {
      name: meta.label,
      value,
      emoji: meta.emoji,
      color: meta.color,
    };
  });
};

const EmotionalTrendsChart = ({ chartData }: { chartData?: any }) => {
  const emotionalTrendsData = mapEmotionsToChartData(chartData?.emotions);
  const hasData =
    Array.isArray(emotionalTrendsData) && emotionalTrendsData?.length > 0;
  if (!hasData) {
    return (
      <>
        <img
          src={images.emptyBar}
          alt="No data"
          style={{ width: "350px", height: "200px", margin: "10px auto" }}
        />
      </>
    );
  }

  const options: Highcharts.Options = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      height: 280,
    },

    title: {
      text: "",
      // align: "left",
      // style: {
      //   fontSize: "24px",
      //   fontWeight: "700",
      //   color: "#390085",
      // },
    },

    xAxis: {
      categories: emotionalTrendsData?.map((d) => d.name),
      lineWidth: 2,
      lineColor: "#666",
      tickLength: 0,
      labels: {
        style: {
          fontSize: "14px",
          color: "#555",
        },
      },
    },

    yAxis: {
      title: { text: "" },
      gridLineWidth: 0,
      lineWidth: 2,
      lineColor: "#666",
      labels: {
        formatter: function () {
          return `${this.value}`;
        },
        style: {
          color: "#555",
        },
      },
    },

    tooltip: {
      enabled: false,
    },

    plotOptions: {
      column: {
        borderRadius: 8,
        pointWidth: 44,
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            const point = this as any;
            const idx = point.point.index;
            return `<span style="font-size:26px">
              ${emotionalTrendsData[idx]?.emoji || ""}
            </span>`;
          },

          y: -18,
        },
      },
    },

    series: [
      {
        type: "column",
        data: emotionalTrendsData?.map((item) => ({
          y: item.value,
          color: item.color,
        })),
      },
    ],

    credits: { enabled: false },
    legend: { enabled: false },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default EmotionalTrendsChart;
